import React from "react";
import styled from "styled-components";





const CartShimmerContainer = styled.div`
display: flex;
flex-direction: row;
justify-content: flex-start;
align-items: flex-start;
width: 99%;
min-width: 300px;
min-height: 200px;
background-color: #fff;
border-radius: 8px;
border: 1px solid rgba(0, 0, 0, 0.12);
margin-bottom: 1rem;


@media (max-width: 900px) {
flex-direction: column;
}

`

const ShimmerItem = styled.div`
  width: 200px;
  height: 140px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 8px;
  margin-top: 1rem;
  margin-left: 1rem;

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }

  @media (max-width: 900px) {
width: 99%;
}
`




export default function CartShimmerSkeleton() {









return(

<CartShimmerContainer>

    <ShimmerItem>

    </ShimmerItem>
     <ShimmerItem>

    </ShimmerItem>
     <ShimmerItem>

    </ShimmerItem>

</CartShimmerContainer>

)

}